import { useMemo } from "react";
import { CONFIG } from "../config-global";
import { ThemeSchema } from "./theme";
import { sysproTheme } from "./syspro-theme/syspro-theme";
import { draycirTheme } from "./draycir-theme/draycir-theme";

const allThemes: ThemeSchema[] = [draycirTheme, sysproTheme];

/*
 * Returns the theme based on the productOemId
 */
// eslint-disable-next-line import/prefer-default-export
export const useTheme = (): ThemeSchema => {
  const theme = useMemo(() => allThemes.find((t) => t.id === CONFIG.site.productOemId) ?? allThemes[0], []);
  return theme;
};
